import { c as _c } from "react/compiler-runtime";
import SvgIcon from '@mui/material/SvgIcon';
import { checkboxClasses } from '@mui/material/Checkbox';

// ----------------------------------------------------------------------

const CheckboxIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M17.9 2.32a5 5 0 0 1 5 4.78v10.22a5 5 0 0 1-4.78 5H7.9a5 5 0 0 1-5-4.79V7.32a5 5 0 0 1 4.78-5zm-.5 1.5h-9a4 4 0 0 0-4 4v9a4 4 0 0 0 4 4h9a4 4 0 0 0 4-4v-9a4 4 0 0 0-4-4" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const CheckboxCheckedIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M17 2a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm-1.62 7.26-4.14 4.12-1.74-1.75a.9.9 0 0 0-1.24 0 .9.9 0 0 0 0 1.24l2.38 2.37q.27.25.6.25.37 0 .63-.25l4.75-4.75a.9.9 0 0 0 0-1.24.9.9 0 0 0-1.24 0" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const CheckboxIndeterminateIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M17 2a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5Zm-2 9H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const MuiCheckbox = {
  /** DEFAULT PROPS */
  defaultProps: {
    size: 'small',
    icon: <CheckboxIcon />,
    checkedIcon: <CheckboxCheckedIcon />,
    indeterminateIcon: <CheckboxIndeterminateIcon />
  },
  /** STYLE */
  styleOverrides: {
    root: ({
      ownerState,
      theme
    }) => ({
      padding: theme.spacing(1),
      ...(ownerState.color === 'default' && {
        [`&.${checkboxClasses.checked}`]: {
          color: theme.vars.palette.text.primary
        }
      }),
      [`&.${checkboxClasses.disabled}`]: {
        color: theme.vars.palette.action.disabled
      }
    })
  }
};
export const checkbox = {
  MuiCheckbox
};